/**
 * Browser download utility.
 *
 * Triggers a file download in the browser by creating a temporary anchor element.
 */

/**
 * Triggers a browser download for a blob with the specified filename.
 *
 * @param blob - The Blob to download
 * @param filename - The filename for the download
 */
export function triggerDownload(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
